import { mergeClasses } from '@griffel/react';
import { useStyles } from './useIconStyles.styles';
import { useBaseIconState } from '../core/useBaseIconState';
export const useIconState = (props, options) => {
    const styles = useStyles();
    const { state, isRtlFlip } = useBaseIconState(props, options);
    state.className = mergeClasses(styles.root, isRtlFlip && styles.rtl, state.className);
    return state;
};
